import { PRIORITY } from "../constants";
export class Item {
    id = crypto.randomUUID();
    createdAt = new Date();
    name;
    description;
    deadline;
    priority;
    notes;
    completed;
    constructor(name, description, deadline, priority, notes) {
        this.name = name || "";
        this.description = description || "";
        this.deadline = deadline || new Date();
        this.priority = priority === undefined ? PRIORITY.NORMAL : priority;
        this.notes = notes || "";
        this.completed = false;
    }
}
